import { useEffect, useRef } from "react";

// Faz o botão "voltar" do navegador FECHAR um overlay-folha (modal/drawer que
// não navega pra outra rota enquanto aberto) em vez de sair da página — essencial
// no Android/navegador in-app do WhatsApp, onde o voltar nativo escaparia da SPA.
//
// Enquanto `open` for true mantém uma entrada-sentinela no histórico; o popstate
// (voltar) chama `close`. Se o overlay for fechado pela UI e a sentinela ainda
// estiver no topo, consome a entrada com history.back() pra não deixar lixo.
export function useBackClose(open: boolean, close: () => void) {
  const closeRef = useRef(close);
  closeRef.current = close;

  useEffect(() => {
    if (!open) return;
    window.history.pushState({ __overlay: true }, "");
    const onPop = () => closeRef.current();
    window.addEventListener("popstate", onPop);
    return () => {
      window.removeEventListener("popstate", onPop);
      if ((window.history.state as { __overlay?: boolean } | null)?.__overlay) {
        window.history.back();
      }
    };
  }, [open]);
}
